<template>
  <div v-if="selectedPlace" class="container">
    <div class="close">
      <router-link to="/">閉じる</router-link>
    </div>
    <div class="title">
      <h3>{{ selectedPlace.name }}</h3>
    </div>
    <div class="address">
      <p>{{ selectedPlace.address }}</p>
    </div>
    <div class="genre" :class="genreClass(selectedPlace.genre)">
      <span></span>
      <p>{{ genreLabel(selectedPlace.genre) }}</p>
    </div>
    <div class="status" :class="statusClass(selectedPlace.status)">
      <p>[{{ statusDetailHeader(selectedPlace.status, selectedPlace.is_nodata) }}]&nbsp;{{ statusDetailLabel(selectedPlace.status, selectedPlace.is_nodata) }}</p>
    </div>
    <div class="chart">
      <div class="chart-inner">
        <Chart :height="298"/>
      </div>
    </div>
    <div class="last-update" v-if="lastUpdateDateTime">
      <p class="notice">※店舗近辺の推定混雑状況です。</p>
      <p>最終更新 : {{ lastUpdateDateTime }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import mixin from './Detail.mixin.js';

export default defineComponent({
  name: 'DetailView',
  mixins: [mixin],
})
</script>

<style scoped lang="scss">
.container {
  width: 520px;
  max-width: 50vw;
  border-left: 1px solid #DDDDDD;
  background-color: rgba(255, 255, 255, 0.97);

  .close {
    margin-top: 17px;
    margin-right: 21px;
    text-align: right;

    a {
      color: #999999;
      font-size: 16px;
    }
  }

  .title {
    margin: 17px 5px 0;
    text-align: center;

    h3 {
      margin: 0;
      font-size: 21px;
      line-height: 31px;
    }
  }

  .address {
    margin: 10px 5px 0;
    text-align: center;

    p {
      margin: 0;
      line-height: 22px;
      font-size: 15px;
    }
  }

  .genre {
    margin-top: 14px;
    display: flex;

    span {
      display: block;
      margin-left: auto;
      width: 24px;
      height: 24px;
      background-size: cover;
    }

    p {
      margin: 0 auto 0 4px;
      line-height: 22px;
      font-size: 15px;
      font-weight: bold;
    }

    &.is-supermarket {
      span {
        background-image: url("@/assets/images/ico24-market.svg");
      }
      p {
        color: #9D7AE0;
      }
    }
    &.is-homecenter {
      span {
        background-image: url("@/assets/images/ico24-homecenter.svg");
      }
      p {
        color: #AF782E;
      }
    }
    &.is-drugstore {
      span {
        background-image: url("@/assets/images/ico24-drag.svg");
      }
      p {
        color: #139351;
      }
    }
    &.is-discountshop {
      span {
        background-image: url("@/assets/images/ico24-discount.svg");
      }
      p {
        color: #F27777;
      }
    }
    &.is-departmall {
      span {
        background-image: url("@/assets/images/ico24-mall.svg");
      }
      p {
        color: #4A5EB4;
      }
    }
  }

  .status {
    margin: 20px 26px 0 29px;
    text-align: center;

    p {
      margin: 0;
      line-height: 43px;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }

    &.is-status-0 {
      background-color: #fff;
      border: 1px solid #CCCCCC;
      p {
        color: #333333;
        line-height: 41px;
      }
    }
    &.is-status-1 {
      background-color: #4AB2F2;
    }
    &.is-status-2 {
      background-color: #9DB41D;
    }
    &.is-status-3 {
      background-color: #D61A1A;
    }
  }

  .chart {
    margin-top: 20px;
    font-family: "Hiragino Kaku Gothic ProN", "Yu Gothic", YuGothic, Verdana, Meiryo, sans-serif;

    &-inner {
      margin-left: auto;
      margin-right: 5px;
      max-width: 486px;
    }
  }

  .last-update {
    position: absolute;
    top: 552px;
    left: 28px;
    right: 28px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;

    p {
      margin: 0 0 3px auto;
      color: #999999;
      font-size: 12px;
    }

    .notice {
      margin-left: 0;
      color: #D13E3E;
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 820px) {
  .container {
    .status {
      p {
        font-size: 16px;
      }
    }
  }
}
</style>
